import { createContext, useEffect } from 'react'
import useCommon from '../hooks/useCommon'

const SearchContext = createContext()

const initialFilter = {
	keyword: ''
}

export const SearchProvider = ({ children }) => {
	const {
		isUpdate,
		setIsUpdate,
		isShowModal,
		setIsShowModal,
		loadingRecord,
		setLoadingRecord,
		loadingTableList,
		setLoadingTableList,
		tableList,
		setTableList,
		tablePaging,
		setTablePaging,
		dataInFilter,
		setDataInFilter,
		dataInControl,
		setDataInControl,
		filter,
		setFilter,
		selectedItem,
		setSelectedItem,
		handleChangeFilter,
		handleResetFilter,
		fetchDataList,
		fetchDataInFilter,
		fetchDataInControl,
		fetchDataRecord,
		handleOrder,
		deleteRecord,
		handleCloseModal,
		saveDraft,
		loadingSave,
		publishItem,
		copyItem,
		exportExcel,
		fetchSearchResultList
	} = useCommon('POP_MarketUpdate', initialFilter)

	useEffect(() => {
		// fetchDataList()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<SearchContext.Provider
			value={{
				isUpdate,
				setIsUpdate,
				isShowModal,
				setIsShowModal,
				loadingRecord,
				setLoadingRecord,
				loadingTableList,
				setLoadingTableList,
				tableList,
				setTableList,
				tablePaging,
				setTablePaging,
				dataInFilter,
				setDataInFilter,
				dataInControl,
				setDataInControl,
				filter,
				setFilter,
				selectedItem,
				setSelectedItem,
				handleChangeFilter,
				handleResetFilter,
				fetchDataList,
				fetchDataInFilter,
				fetchDataInControl,
				fetchDataRecord,
				handleOrder,
				deleteRecord,
				handleCloseModal,
				saveDraft,
				loadingSave,
				publishItem,
				copyItem,
				exportExcel,
				fetchSearchResultList
			}}
		>
			{children}
		</SearchContext.Provider>
	)
}

export default SearchContext
